import { GenericHeader, GenericFooter } from '@icij/murmur'

import ChartRoute from './ChartRoute'
import ChartAllegedCorruptPraticesByCountry from '../components/ChartAllegedCorruptPraticesByCountry'

import Home from '../views/Home.vue'

export { guards } from './guards'
export { ChartRoute }
export const routes = [
  {
    path: '/',
    name: 'Home',
    props: {
      header: {
        noHeadroom: true,
        position: 'static'
      }
    },
    components: {
      header: GenericHeader,
      footer: GenericFooter,
      default: Home
    }
  },
  {
    path: '/embed/',
    name: 'Embed',
    components: {
      default: Home
    }
  },
  ChartRoute.create({ title: 'Widespread allegations of wrongdoing at Ericsson', chart: ChartAllegedCorruptPraticesByCountry })
]
